import {
  Button,
  ButtonVariants,
  FormControlSizes,
  IconName,
  canViewDeepDive,
  useMarketAccountsContext,
  type ButtonProps,
  type Security,
} from '@talos/kyoko';
import { useCallback } from 'react';
import styled from 'styled-components';
import { useNavigateToDeepDiveOrMultileg } from '../../hooks/useNavigateToDeepDiveOrMultileg';
import { filterMarketAccounts, filterMarkets } from '../MarketAccountSelectionList/utils';

interface DeepDiveButtonProps extends Omit<ButtonProps, 'security'> {
  security?: Security;
  selectedMarketAccounts?: string[];
  selectedMarkets?: string[];
  selectedAggregation?: string;
  size?: FormControlSizes;
  disabled?: boolean;
  variant?: ButtonVariants;
}

export function DeepDiveButton({
  security,
  selectedMarketAccounts,
  selectedMarkets,
  selectedAggregation,
  size = FormControlSizes.Small,
  disabled = false,
  variant = ButtonVariants.Default,
  ...props
}: DeepDiveButtonProps) {
  const { marketAccountsByMarket, marketAccountsByName } = useMarketAccountsContext();
  const navigateToDeepDiveOrMultileg = useNavigateToDeepDiveOrMultileg();

  const markets = selectedMarkets && filterMarkets(selectedMarkets, marketAccountsByMarket);
  const marketAccounts =
    selectedMarketAccounts &&
    filterMarketAccounts(selectedMarketAccounts, selectedMarkets ?? [], marketAccountsByMarket, marketAccountsByName);

  const handleOnClick = useCallback(() => {
    navigateToDeepDiveOrMultileg(security, marketAccounts, markets, selectedAggregation);
  }, [security, marketAccounts, markets, selectedAggregation, navigateToDeepDiveOrMultileg]);

  if (!disabled && !canViewDeepDive(security)) {
    return null;
  }

  return (
    <DeepDiveButtonElement
      data-testid="deepdive-button"
      size={size}
      endIcon={IconName.Deepdive}
      onClick={handleOnClick}
      disabled={disabled}
      variant={variant}
      {...props}
    >
      DeepDive
    </DeepDiveButtonElement>
  );
}

export const DeepDiveButtonElement = styled(Button)``;
